import React from "react";
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import Categories from "../components/Categories";
import ActivitiesShowcase from "../components/ActivitiesShowcase";
import Centers from "../components/Centers";
import Videos from "../components/Videos";
import FAQs from "../components/FAQs";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const LandingPage: React.FC = () => {
  return (
    <div>
      <Hero />
      <Benefits />
      <Categories />
      <ActivitiesShowcase />
      <Centers />
      <Videos />
      <FAQs />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;
